import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW7300Model } from '../kymw7300/kymw7300.model';
import { KYMW7301Component } from '../kymw7301/kymw7301.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { DeleteCouponListService } from './api-services/delete-coupon-list.service';
import { GetCouponListService } from './api-services/get-coupon-list.service';
import { Router } from '@angular/router';
import { TextInputComponent } from 'src/app/commons/kymw02/text-input/text-input/text-input.component';

export const enum mode {
  NewMode = "1",
  EditMode = "2",
}

/**
 * 注文単位値引クーポン一覧画面を管理するクラス
 *
 * @export KYMW7300Component
 * @class KYMW7300Component
 */
@Component({
  selector: 'app-kymw7300',
  templateUrl: 'kymw7300.component.html',
  styleUrls: ['kymw7300.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7300Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  public model: KYMW7300Model = new KYMW7300Model();

  private context = new Menu(document.createElement('div'), {
    displayMemberPath: 'caption',
    selectedValuePath: 'cmd',
    itemsSource: [{ caption: '詳細', cmd: 'detail', enabled: true }],
    command: {
      canExecuteCommand: param => param.enabled,
    },
    itemClicked: () => {
      if (this.context.selectedValue === 'detail') this.detail();
    },
  });

  @ViewChild('txti_couponIssueCatalog', { static: true }) txti_couponIssueCatalog: TextInputComponent;
  @ViewChild('dtg_Main', { static: true }) dtg_Main: FlexGrid;

  /**
   * Creates an instance of KYMW7300Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {DeleteCouponListService} deleteCouponListService
   * @param {GetCouponListService} getCouponListService
   * @memberof KYMW7300Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private deleteCouponListService: DeleteCouponListService,
    private getCouponListService: GetCouponListService,
    private elementRef: ElementRef,
    private router: Router,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7300Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7300';

    this.model.couponCategory = '04';
    this.dtg_Main.columnHeaders.rows[0].height = 50;

    // 初期フォーカス
    this.txti_couponIssueCatalog.setFocus();
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW7300Component
   */
  public ngAfterViewInit(): void {
    if (this.dtg_Main) {
      this.dtg_Main.itemsSourceChanged.addHandler(
        (_g: FlexGrid, _e: EventArgs) => {
          _g.select(-1, -1);
        }
      );
      // チェックボックスのあたり判定制御
      this.dtg_Main.hostElement.addEventListener('click', e => {
        const ht = this.dtg_Main.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell && ht.col === 0) {
          const val = this.dtg_Main.getCellData(ht.row, ht.col, false);
          this.dtg_Main.setCellData(ht.row, ht.col, val ? false : true);
        }
      });
      // コンテキストメニュー
      this.dtg_Main.hostElement.addEventListener('contextmenu', e => {
        e.preventDefault();
        DataGridUtil.showContextMenu(this.dtg_Main, this.context, e);
      });
    }
  }

  /**
   * ボタン押下 検索
   *
   * @memberof KYMW7300Component
   */
  public search() {
    // 検索時の条件を保持
    this.model.searchedCouponIssueCatalog = this.model.couponIssueCatalog;
    this.model.searchedReceiptCatalog = this.model.receiptCatalog;
    this.model.searchedCouponOrderCd = this.model.couponOrderCd;
    this.model.searchedCouponCategory = this.model.couponCategory;
    this.model.searchedCouponName = this.model.couponName;

    // ページ設定
    const page = 1;

    // 検索実行
    this.getCouponListService.execute(this.model, page, () => {
      this.model.page = page;
    });
  }

  /**
   * ボタン押下 新規追加
   *
   * @memberof KYMW7300Component
   */
  public add() {
    // 注文単位値引クーポン登録ダイアログ表示
    const componentRef = this.dialogService.openModal(KYMW7301Component);
    const instance = componentRef.componentInstance as KYMW7301Component;
    instance.setParams(mode.NewMode, null, null);
    instance.callbackRegist = () => {  // 「登録/更新」ボタン時
      this.research();  // 現在の検索条件&ページで再検索
    };
    instance.closeFunction = () => {  // 「✕」ボタン時
      componentRef.close();
    };
  }

  /**
   * ボタン押下 コピー
   *
   * @memberof KYMW7300Component
   */
  public copy() {
    if (this.model.couponList.every(_t => !_t.check)) {
      // 選択のチェックが0件の場合
      this.dialogService.openAlertGetMessage('E0103', ['注文単位値引クーポン']);
      return;
    }

    const selectCouponList = this.model.couponList.filter(_g => _g.check);
    if (selectCouponList.length >= 2) {
      // チェックが複数ある場合
      this.dialogService.openAlertGetMessage('E0541', ['注文単位値引クーポン']);
      return;
    }

    if (selectCouponList[0].couponCategory === '05') {
      // クーポン種別が「05：クーポンチラシ」の場合コピー不可
      this.dialogService.openAlertGetMessage('E0660', ['コピー']);
      return;
    }

    // 注文単位値引クーポン登録ダイアログ表示
    const componentRef = this.dialogService.openModal(KYMW7301Component);
    const instance = componentRef.componentInstance as KYMW7301Component;
    instance.setParams(
      mode.NewMode,
      selectCouponList[0].couponGoodsNo,
      selectCouponList[0].couponReceiptCatalogStart
    );
    instance.callbackRegist = () => {  // 「登録/更新」ボタン時
      this.research();  // 現在の検索条件&ページで再検索
    };
    instance.closeFunction = () => {  // 「✕」ボタン時
      componentRef.close();
    };
  }

  /**
   * ボタン押下 削除
   *
   * @memberof KYMW7300Component
   */
  public del() {
    if (this.model.couponList.every(_t => !_t.check)) {
      // 選択のチェックが0件の場合
      this.dialogService.openAlertGetMessage('E0103', ['注文単位値引クーポン']);
      return;
    }

    this.dialogService.openAlertGetMessage('Q0106', ['注文単位値引クーポン'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        const delVo = new KYMW7300Model();
        delVo.couponList = this.model.couponList.filter(_g => _g.check);
        // 削除処理実行
        this.deleteCouponListService.execute(delVo, () => {
          this.dialogService.openAlertGetMessage('I0506', [], () => {
            // 再描画処理
            let page = this.model.page;
            if (page !== 1 && this.model.totalNum === this.model.endDispNum) {
              // 最終ページを表示している場合（1ページ目除く）
              if (this.model.couponList.every(_t => _t.check)) {
                // ページ内全て削除した場合、ページをデクリメントする
                page = this.model.page - 1;
              }
            }
            // 検索ボタン押下時の条件を設定
            this.setSearchedCondition();
            // 検索実行
            this.getCouponListService.execute(this.model, page, () => {
              this.model.page = page;
            });
          });
        });
      }
    });
  }

  /**
   * ボタン押下 ページネーション prev
   *
   * @memberof KYMW7300Component
   */
  public prev() {
    // 検索ボタン押下時の条件を設定
    this.setSearchedCondition();
    // ページ設定
    const page = (this.model.page < 1) ? 1 : this.model.page - 1;

    // 検索実行
    this.getCouponListService.execute(this.model, page, () => {
      this.model.page = page;
    });
  }

  /**
   * ボタン押下 ページネーション next
   *
   * @memberof KYMW7300Component
   */
  public next() {
    // 検索ボタン押下時の条件を設定
    this.setSearchedCondition();
    // ページ設定
    const page = (this.model.page < 1) ? 1 : this.model.page + 1;

    // 検索実行
    this.getCouponListService.execute(this.model, page, () => {
      this.model.page = page;
    });
  }

  /**
   * 検索ボタン押下時の条件設定
   */
  private setSearchedCondition(): void {
    this.model.couponIssueCatalog = this.model.searchedCouponIssueCatalog;
    this.model.receiptCatalog = this.model.searchedReceiptCatalog;
    this.model.couponOrderCd = this.model.searchedCouponOrderCd;
    this.model.couponCategory = this.model.searchedCouponCategory;
    this.model.couponName = this.model.searchedCouponName;
  }

  /**
   * コンテキストメニュー 詳細
   *
   * @memberof KYMW7300Component
   */
  public detail() {
    // 注文単位値引クーポン登録ダイアログ表示
    const componentRef = this.dialogService.openModal(KYMW7301Component);
    const instance = componentRef.componentInstance as KYMW7301Component;
    instance.setParams(
      mode.EditMode,
      this.dtg_Main.selectedRows[0].dataItem.couponGoodsNo,
      this.dtg_Main.selectedRows[0].dataItem.couponReceiptCatalogStart
    );
    instance.callbackRegist = () => {  // 「登録/更新」ボタン時
      this.research();  // 現在の検索条件&ページで再検索
    };
    instance.closeFunction = () => {  // 「✕」ボタン時
      componentRef.close();
    };
  }

  /**
   * 再検索実行
   *
   * @memberof KYMW7300Component
   */
  private research() {
    // 検索ボタン押下時の条件を設定
    this.setSearchedCondition();
    // ページ設定
    const page = (this.model.page < 1) ? 1 : this.model.page;
   // 検索実行
    this.getCouponListService.execute(this.model, page, () => {
      this.model.page = page;
    });
  }

  /**
   * クーポン企画回の値を変更したとき
   */
  eventCouponIssueCatalog_CHANGEHandler() {
    this.clearCouponList();
  }

  /**
   * クーポン注文コードの値を変更したとき
   */
  eventCouponOrderCd_CHANGEHandler() {
    this.clearCouponList();
  }

  /**
   * 受付企画回の値を変更したとき
   */
  eventReceiptCatalog_CHANGEHandler() {
    this.clearCouponList();
  }

  /**
   * クーポン種別の値を変更したとき
   */
  eventCouponCategory_CHANGEHandler() {
    this.clearCouponList();
  }

  /**
   * クーポン名の値を変更したとき
   */
  eventCouponName_CHANGEHandler() {
    this.clearCouponList();
  }

  /**
   * 一覧表示を初期化する
   */
  clearCouponList() {
    this.getCouponListService.clearCouponList();
  }
}
